// Costanti e helper client per la configurazione della sorgente esterna di un'anagrafica.

export const SOURCE_TYPES = [
  { code: 'csv', label: 'CSV caricato a mano', hint: 'Carichi un file quando vuoi aggiornare le voci' },
  { code: 'sap', label: 'SAP OData', hint: 'Legge una entity set di un servizio OData v2' },
  { code: 'crm-rest', label: 'Servizio REST', hint: 'Legge una lista JSON da un indirizzo HTTP' },
];

export const SYNC_POLICIES = [
  {
    code: 'full-replace',
    label: 'Sostituisci tutto',
    hint: 'Cancella le voci e le ricrea dalla sorgente; serve un file senza righe scartate',
  },
  {
    code: 'upsert',
    label: 'Aggiorna per chiave',
    hint: 'Aggiunge le nuove e aggiorna quelle con la stessa chiave',
  },
  {
    code: 'delta',
    label: 'Solo le modifiche dopo l’ultimo sync',
    hint: 'Chiede alla sorgente le righe cambiate dopo l’ultima esecuzione riuscita',
  },
];

export const CRON_PRESETS = [
  { label: 'Ogni ora', cron: '0 0 * * * ?' },
  { label: 'Ogni giorno alle 02:00 UTC', cron: '0 0 2 * * ?' },
  { label: 'Ogni 15 minuti', cron: '0 */15 * * * ?' },
  { label: 'Personalizzato', cron: null },
];

// Valore con cui il backend restituisce i segreti: rimandarlo invariato li conserva.
export const SECRET_SENTINEL = '********';

export const MAX_UPLOAD_BYTES = 50 * 1024 * 1024;

export const isSyncable = (registry) =>
  !!registry && registry.internal !== true && SOURCE_TYPES.some((t) => t.code === registry.sourceType);

export const emptySourceConfig = (code) => {
  switch (code) {
    case 'csv':
      return {
        source: { delimiter: ',', charset: 'UTF-8' },
        mapping: {},
        sync: { policy: 'full-replace' },
      };
    case 'sap':
      return {
        source: { serviceUrl: '', username: '', password: '', headers: {} },
        mapping: {},
        sync: { policy: 'full-replace', schedule: '' },
      };
    case 'crm-rest':
      return {
        source: { url: '', headers: {}, auth: { type: 'none' }, itemsPath: '' },
        mapping: {},
        sync: { policy: 'full-replace', schedule: '' },
      };
    default:
      return { source: {}, mapping: {}, sync: { policy: 'full-replace' } };
  }
};

export const fieldErrorsByPath = (fieldErrors) => {
  if (!Array.isArray(fieldErrors)) return {};
  return fieldErrors.reduce((acc, e) => {
    acc[e.field] = e.message;
    return acc;
  }, {});
};

// Toglie dal mapping le chiavi che non sono più proprietà dello schema (campo rimosso o rinominato):
// il backend rifiuterebbe il salvataggio e l'editor non le mostra, quindi non si potrebbero togliere.
// Non muta l'input; restituisce lo stesso oggetto se non c'è nulla da togliere.
export const pruneMapping = (sourceConfig, schema) => {
  const mapping = sourceConfig?.mapping;
  const properties = schema?.properties;
  if (!mapping || typeof mapping !== 'object' || !properties || typeof properties !== 'object') {
    return sourceConfig;
  }
  const kept = Object.fromEntries(
    Object.entries(mapping).filter(([key]) => Object.prototype.hasOwnProperty.call(properties, key)),
  );
  if (Object.keys(kept).length === Object.keys(mapping).length) return sourceConfig;
  return { ...sourceConfig, mapping: kept };
};

export const sourceTypeLabel = (code) => {
  if (!code) return '';
  return SOURCE_TYPES.find((t) => t.code === code)?.label || code;
};
